module.exports = __webpack_public_path__ + "25afcb36215b4e4c7a9aec37caa8128f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mine_CV_2_25.pdf
// module id = dXxn
// module chunks = 1